/**
 *
 * DrmConfiguration for player, to setup per type.
 * @param {String} type,
 * @param {Object} configuration
 * @param {String} configuration.laUrl
 * @param {String} [configuration.certificateUrl]
 * @param {String} configuration.token
 * @param {String} [configuration.kid]
 * @constructor
 */
import ObjectUtils from '../../util/object_utils';
import ErrorHandler from '../error_handler/error_handler';
import LanguageManager from '../language_manager/language_manager';

function DrmConfiguration(type, configuration) {
    this.type = type;
    this.configuration = configuration;

    this._validate();
}

DrmConfiguration.prototype._validate = function() {
    var type = this.type || ObjectUtils.assertEmpty(this.type, 'type');

    if (DrmConfiguration.DRM_ALLOWED.indexOf(this.type) === -1) {
        ErrorHandler.throwError({
            message: LanguageManager.get('error_571107_generic'),
            code: 571122

        }, {
            reason: 'Given DRM is not allowed. Use DrmConfiguration.<DRM_TYPE> to choose a DRM.',
            given: this.type,
            allowed: DrmConfiguration.DRM_ALLOWED.join(',')
        });
    }

    // Checks that count for all DRM types
    ObjectUtils.assertEmpty(this.configuration.token, 'configuration.token');

    // Checks per DRM TYPE
    switch (type) {
        case DrmConfiguration.FAIRPLAY:
            ObjectUtils.assertEmpty(this.configuration.certificateUrl, 'configuration.certificateUrl');
            ObjectUtils.assertEmpty(this.configuration.laUrl, 'configuration.laUrl');
            break;
        case DrmConfiguration.WIDEVINE:
            ObjectUtils.assertEmpty(this.configuration.laUrl, 'configuration.laUrl');
            // ObjectUtils.assertEmpty(this.configuration.kid, "configuration.kid");
            break;
    }
};

DrmConfiguration.prototype.asJson = function() {
    return this.configuration;
};

// LicenseTypes
DrmConfiguration.FAIRPLAY = 'fairplay';
DrmConfiguration.ACCESS = 'access';
DrmConfiguration.WIDEVINE = 'widevine';
DrmConfiguration.PLAYREADY = 'playready';
DrmConfiguration.PRIMETIME = 'primetime';
DrmConfiguration.DRM_ALLOWED = [DrmConfiguration.FAIRPLAY, DrmConfiguration.ACCESS, DrmConfiguration.WIDEVINE, DrmConfiguration.PLAYREADY, DrmConfiguration.PRIMETIME];

module.exports = DrmConfiguration;



// WEBPACK FOOTER //
// ./src/modules/drm/drmConfiguration.js